import React from 'react';
import { componentService } from 'js/services/component.service';

export const TermsAndConditionsVerification = React.lazy(() => import(/* webpackChunkName: "terms-and-conditions-verification" */ './TermsAndConditionsVerification'));

componentService.registerPageComponents({ 'terms-conditions-verification': TermsAndConditionsVerification });
